import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=e242f944&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=e242f944&prod&lang=scss&scoped=true"
import style1 from "./Notification.vue?vue&type=style&index=1&id=e242f944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e242f944",
  null
  
)

export default component.exports